// language=GraphQL
export const ALL_IFRAME_BLOCKS_QUERY = `query Query {
  iframeBlocks: cmsIframeBlocks {
    id
    url
    minHeight
  }
}`

// language=GraphQL
export const SINGLE_IFRAME_BLOCK_QUERY = `query Query($id: ID!) {
  iframeBlock: cmsIframeBlock(id: $id) {
    id
    url
    minHeight
  }
}`

// language=GraphQL
export const CREATE_IFRAME_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsIframeBlockInput) {
    iframeBlock: createCmsIframeBlock(input: $input) {
      id
      url
      minHeight
    }
  }`

// language=GraphQL
export const UPDATE_IFRAME_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsIframeBlockInput) {
    iframeBlock: updateCmsIframeBlock(input: $input) {
      id
      url
      minHeight
    }
  }`

// language=GraphQL
export const DELETE_IFRAME_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsIframeBlockInput) {
    deleteCmsIframeBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_IFRAME_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsIframeBlockInput) {
    forceDeleteCmsIframeBlock(input: $input) {
      success
    }
  }`
